import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  FaBullhorn,
  FaGraduationCap,
  FaLandmark,
  FaHouse,
  FaSackDollar,
  FaCircleCheck,
  FaWheatAwn,
  FaPenToSquare,
  FaClipboardCheck,
  FaBuilding,
  FaPlaneDeparture,
  FaChevronDown,
  FaIndianRupeeSign,
  FaDrone,
  FaTrophy,
} from "react-icons/fa6";
import { PiDrone } from "react-icons/pi";
import { createLead, clearStatus } from "../redux/slice/hduySlice";

const BANNERS = [
  "/WEBPAGEBANNER1.png",
  "/WEBPAGEBANNER2.png",
];

const content = {
  en: {
    langBtn: "हिन्दी",
    govBar:
      "Government of Haryana | Haryana Scheduled Castes Finance & Development Corporation",

    taglineHeading: "Become a Tech Entrepreneur - Right From Where You Are",
    tagline: [
      "Today's youth don't just want jobs… they want to build their own self-reliant business.",
      "The Haryana Government brings you a powerful opportunity - where Technology + Drone Skills + Income = Your Own Business.",
      "This is not just a scheme. It is your launchpad to financial independence.",
    ],

    aboutHeading: "About the Scheme",
    aboutLead:
      "A special initiative by the Haryana Government aimed at empowering Scheduled Caste (SC) youth with employment and entrepreneurship opportunities.",
    aboutCards: [
      {
        img: "/Vector-1.png",
        title: "Government Initiative",
        text: "Empowering SC Youth with Employment & Entrepreneurship Opportunities.",
        color: "#138808",
        bg: "#eef7ee",
      },
      {
        img: "/Vector-2.png",
        title: "Training Model",
        text: "1 Drone Entrepreneur per Area - trained to provide drone-based services locally.",
        color: "#FF9933",
        bg: "#fff5ec",
      },
      {
        img: "/Vector-3.png",
        title: "Multiple Uses of Drones",
        text: "Drones will improve agriculture and productivity through crop spraying, monitoring, land mapping, surveys, and aerial photography & videography.",
        color: "#138808",
        bg: "#eef7ee",
      },
      {
        img: "/Vector-4.png",
        title: "Urban & Rural Youth Empowerment",
        text: "Urban & Rural youth will become self-reliant and create a sustainable source of income and employment.",
        color: "#FF9933",
        bg: "#fff5ec",
      },
    ],
    aboutTagline: "From Skill to Income - At Local Level",

    initiativeHeading: "Under This Initiative",
    initiative: [
      { img: "/1stimage.png", text: "1 certified drone entrepreneur per Area" },
      { img: "/2ndimage.png", text: "Deliver high-demand drone services locally" },
      { img: "/3rdimage.png", text: "Become a business owner - not just a worker" },
    ],

    eligibilityHeading: "Are You Eligible?",
    // eligibilityIntro: "If you have these four things, this opportunity is for you:",
    eligibility: [
      "Must have passed 10th standard",
      "Must be a resident of Haryana",
      "Scheduled Caste (SC)",
      "Age between 18 to 45 years",
      "Annual income should be up to ₹3 lakh",
      "Entrepreneurial mindset",
    ],

    benefitsHeading: "Massive Benefits You Can't Ignore",
    benefits: [
      { Icon: FaGraduationCap, color: "#FF9933", text: "8 days of free training" },
      { Icon: FaLandmark,      color: "#1e88e5", text: "Training at a DGCA-approved drone pilot training center" },
      { Icon: FaHouse,         color: "#138808", text: "Free stay, meals & travel during training" },
      { Icon: FaIndianRupeeSign,    color: "#d4a017", text: "Subsidy on loan for drone purchase after training" },
      // { Icon: FaCircleCheck,   color: "#138808", text: "100% subsidy on training" },
      { Icon: FaWheatAwn,      color: "#FF9933", text: "Work opportunity in your own Area" },
    ],

    earningHeading: "Earning Potential",
    earningValue: "₹9–10 Lakhs",
    earningUnit: "per year",
    earningSub: "Work from your area, on your own terms, running your own business.",

    whyHeading: "Why This is a Once-in-a-Lifetime Opportunity",
    why: [
      "Government-backed - 100% trust",
      "Reserved for SC youth",
      "Only 1 selection per Area",
      "No competition after selection",
      "Future-ready career",
      "Combination of agriculture + technology",
    ],

    howHeading: "Simple Step-by-Step Process",
    howStep: "Step",
    how: [
      { Icon: FaPenToSquare,    text: "Fill the application form" },
      { Icon: FaClipboardCheck, text: "Take a basic test" },
      { Icon: FaBuilding,       text: "Visit your local CSC centre & submit documents" },
      { Icon: PiDrone,      text: "Become a certified drone pilot" },
      { Icon: FaIndianRupeeSign,     text: "Start earning in your Area" },
    ],

    workHeading: "Your Future Business Services",
    workIntro: "Farmers NEED these services - you become their go-to expert.",
    workEarningLabel: "Earning Potential",
    work: [
      {
        img: "/hduy_pic2.jpg.jpeg",
        text: "Crop spraying (fertilizers & pesticides)",
        earning: "₹15,000 – ₹40,000",
      },
      {
        img: "/hduy_pic1.jpg.jpeg",
        text: "Land mapping & surveys",
        earning: "₹20,000 – ₹50,000",
      },
      {
        img: "/hduy_pic3.jpg.jpeg",
        text: "Smart agriculture services",
        earning: "₹20,000 – ₹45,000",
      },
    ],

    imagineHeading: "Imagine This",
    imagine: [
      "Imagine running your own drone business in your village…",
      "People calling you for work —",
    ],
    imagineQuoteImg: "/dronequotebanner02.png",

    urgencyHeading: "Only 500 Seats Across Haryana",
    urgency: [
      "Only 1 selection per Area",
      "First come, First served!",
    ],
    urgencyNote: "If you don't apply now… someone else will take your place.",

    popupHeading: "⚠️ Important Deadline",
    popupMsg: "The last date for applying for drone training is",
    popupDate: "15 August 2026",
    popupBtn: "Apply Now",
    popupClose: "Close",

    ctaHeading: "Don't Wait. Act Now.",
    ctaSub: "Apply now and become the Drone Entrepreneur of your Area.",

    formHeading: "Apply Now For Drone Training",
    formSub: "Limited seats - Become the Drone Entrepreneur of your Area",
    name: "Full Name",
    email: "Email Address (Optional)",
    phone: "Phone Number",
    address: "District",
    familyId: "Family ID (PPP)",
    familyIdPlaceholder: "Enter 8-digit Parivar Pehchan Patra ID",
    familyIdError: "Invalid Family ID — must be 8–12 alphanumeric characters",
    isSC: "Do you belong to the Scheduled Caste (SC) category?",
    yes: "Yes",
    no: "No",
    submit: "Submit Application",
    submitting: "Submitting...",
    successMsg: "Application submitted successfully!",
    errorMsg: "Something went wrong. Please try again.",
    validation: "Please fill all the required fields correctly.",
  },
  hi: {
    langBtn: "English",
    govBar:
      "हरियाणा सरकार | हरियाणा अनुसूचित जाति वित्त एवं विकास निगम",

    taglineHeading: "अब जहाँ हैं वहीं से बनें टेक्नोलॉजी उद्यमी",
    tagline: [
      "आज का युवा सिर्फ नौकरी नहीं… अपना आत्मनिर्भर बिज़नेस बनाना चाहता है।",
      "हरियाणा सरकार आपके लिए लेकर आई है एक ऐसा मौका - जहां तकनीक + ड्रोन स्किल्स + कमाई = आपका खुद का बिज़नेस।",
      "यह सिर्फ एक योजना नहीं है। यह आपकी आर्थिक आज़ादी की उड़ान का लॉन्चपैड है।",
    ],

    aboutHeading: "योजना के बारे में",
    aboutLead:
      "हरियाणा सरकार की एक विशेष पहल, जिसका उद्देश्य अनुसूचित जाति (SC) के युवाओं को रोजगार और उद्यमिता के अवसर प्रदान करना है।",
    aboutCards: [
      {
        img: "/Vector-1.png",
        title: "सरकारी पहल",
        text: "SC युवाओं को रोजगार और उद्यमिता के अवसरों से सशक्त बनाना।",
        color: "#138808",
        bg: "#eef7ee",
      },
      {
        img: "/Vector-2.png",
        title: "ट्रेनिंग मॉडल",
        text: "हर क्षेत्र में 1 ड्रोन उद्यमी - स्थानीय स्तर पर ड्रोन सेवाओं के लिए प्रशिक्षित।",
        color: "#FF9933",
        bg: "#fff5ec",
      },
      {
        img: "/Vector-3.png",
        title: "ड्रोन के उपयोग",
        text: "ड्रोन से फसल स्प्रे, निगरानी, भूमि मैपिंग, सर्वे और एरियल फोटोग्राफी/वीडियोग्राफी के जरिए कृषि और उत्पादकता बढ़ेगी।",
        color: "#138808",
        bg: "#eef7ee",
      },
      {
        img: "/Vector-4.png",
        title: "ग्रामीण युवा सशक्तिकरण",
        text: "शहरी और ग्रामीण युवा आत्मनिर्भर बनेंगे और आय व रोजगार का स्थायी साधन बनाएंगे।",
        color: "#FF9933",
        bg: "#fff5ec",
      },
    ],
    aboutTagline: "कौशल से आय तक - स्थानीय स्तर पर",

    initiativeHeading: "इस पहल के तहत",
    initiative: [
      { img: "/1stimage.png", text: "हर क्षेत्र में 1 प्रमाणित ड्रोन उद्यमी" },
      { img: "/2ndimage.png", text: "उच्च मांग वाली ड्रोन सेवाएं आपके क्षेत्र में" },
      { img: "/3rdimage.png", text: "आप एक स्थानीय व्यवसाय के मालिक बनेंगे" },
    ],

    eligibilityHeading: "क्या आप योग्य हैं?",
    // eligibilityIntro: "अगर ये 4 चीज़ें आपके पास हैं… तो ये मौका आपके लिए ही है:",
    eligibility: [
      "10वीं पास होना आवश्यक",
      "हरियाणा का निवासी होना अनिवार्य",
      "अनुसूचित जाति (SC)",
      "उम्र 18 से 45 साल",
      "वार्षिक आय अधिकतम 3 लाख",
      "खुद का काम शुरू करने की इच्छा",
    ],

    benefitsHeading: "मुख्य लाभ",
    benefits: [
      { Icon: FaGraduationCap, color: "#FF9933", text: "8 दिन की निशुल्क प्रशिक्षण" },
      { Icon: FaLandmark,      color: "#1e88e5", text: "DGCA द्वारा मान्यता प्राप्त ड्रोन पायलट प्रशिक्षण केंद्र में ट्रेनिंग" },
      { Icon: FaHouse,         color: "#138808", text: "ट्रेनिंग के दौरान निशुल्क रहना-खाना और यातायात की सुविधा" },
      { Icon: FaIndianRupeeSign,    color: "#d4a017", text: " ट्रेनिंग के बाद ड्रोन के लिए लोन पर सब्सिडी" },
      // { Icon: FaCircleCheck,   color: "#138808", text: "Training पर 100% Subsidy" },
      { Icon: FaWheatAwn,      color: "#FF9933", text: "अपने क्षेत्र में काम करने का अवसर" },
    ],

    earningHeading: "कमाई का मौका",
    earningValue: "₹9–10 लाख",
    earningUnit: "सालाना",
    earningSub: "अपने क्षेत्र में रहकर… अपनी शर्तों पर… अपना बिज़नेस चलाकर।",

    whyHeading: "क्यों जुड़ें?",
    why: [
      "सरकारी योजना - 100% भरोसा",
      "केवल SC युवाओं के लिए आरक्षित",
      "हर क्षेत्र में सिर्फ 1 चयन",
      "चयन के बाद कोई competition नहीं",
      "भविष्य में करियर को लेकर चिंता नहीं",
      "कृषि + तकनीक का नया अवसर",
    ],

    howHeading: "कैसे काम करता है?",
    howStep: "स्टेप",
    how: [
      { Icon: FaPenToSquare,    text: "ऑनलाइन रजिस्ट्रेशन करें" },
      { Icon: FaClipboardCheck, text: "एक आसान टेस्ट दें" },
      { Icon: FaBuilding,       text: "चयन के बाद डॉक्युमेंट वेरिफिकेशन" },
      { Icon: PiDrone, text: "10 दिन की प्रोफेशनल ट्रेनिंग" },
      { Icon: FaIndianRupeeSign,     text: "ड्रोन के साथ बिज़नेस शुरू करें" },
    ],

    workHeading: "आप क्या काम करेंगे?",
    workIntro: "किसानों को इन सेवाओं की ज़रूरत है - आप उनके भरोसेमंद विशेषज्ञ बनेंगे।",
    workEarningLabel: "कमाई की क्षमता",
    work: [
      {
        img: "/hduy_pic2.jpg.jpeg",
        text: "फसल स्प्रे (कीटनाशक / उर्वरक)",
        earning: "₹15,000 – ₹40,000",
      },
      {
        img: "/hduy_pic1.jpg.jpeg",
        text: "जमीन की मैपिंग और सर्वे",
        earning: "₹20,000 – ₹50,000",
      },
      {
        img: "/hduy_pic3.jpg.jpeg",
        text: "स्मार्ट कृषि सेवाएं",
        earning: "₹20,000 – ₹45,000",
      },
    ],

    imagineHeading: "कल्पना करें",
    imagine: [
      "आप अपने गांव में… अपने नाम से… अपनी कमाई से…",
      "एक ड्रोन बिज़नेस चला रहे हैं… और लोग आपको बुला रहे हैं —",
    ],
    imagineQuoteImg: "/dronequotebanner01.png",

    urgencyHeading: "सीटें सीमित हैं - पूरे हरियाणा में सिर्फ 500",
    urgency: [
      "हर क्षेत्र में सिर्फ 1 चयन",
      "पहले आओ, पहले पाओ",
    ],
    urgencyNote: "अगर आपने अभी आवेदन नहीं किया… तो कोई और आपकी जगह ले लेगा।",

    popupHeading: "⚠️ महत्वपूर्ण सूचना",
    popupMsg: "ड्रोन प्रशिक्षण के लिए आवेदन की अंतिम तिथि है",
    popupDate: "15 अगस्त 2026",
    popupBtn: "अभी आवेदन करें",
    popupClose: "बंद करें",

    ctaHeading: "अभी आवेदन करें",
    ctaSub: "अभी आवेदन करें और अपने क्षेत्र के ड्रोन उद्यमी बनें।",

    formHeading: "ड्रोन प्रशिक्षण के लिए अभी आवेदन करें।",
    formSub: "सीमित सीटें - अपने क्षेत्र के ड्रोन उद्यमी बनें",
    name: "पूरा नाम",
    email: "ईमेल पता (वैकल्पिक)",
    phone: "फोन नंबर",
    address: "जिला",
    familyId: "परिवार पहचान पत्र (PPP)",
    familyIdPlaceholder: "8 अंकों का परिवार पहचान पत्र ID दर्ज करें",
    familyIdError: "अमान्य Family ID — 8–12 अक्षरांकीय अक्षर होने चाहिए",
    isSC: "क्या आप अनुसूचित जाति (SC) श्रेणी से हैं?",
    yes: "हाँ",
    no: "नहीं",
    submit: "आवेदन जमा करें",
    submitting: "जमा हो रहा है...",
    successMsg: "आवेदन सफलतापूर्वक जमा हुआ!",
    errorMsg: "कुछ गलत हुआ। कृपया पुनः प्रयास करें।",
    validation: "कृपया सभी आवश्यक फ़ील्ड सही ढंग से भरें।",
  },
};

const HduyLandingPage = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((s) => s.lead);
  const [lang, setLang] = useState("hi");
  const t = content[lang];
  const [form, setForm] = useState({ name: "", email: "", phone: "", district: "", isSC: null });
  const [familyIdError, setFamilyIdError] = useState("");
  const [showPopup, setShowPopup] = useState(() => !sessionStorage.getItem("hduy_popup_shown"));

  const handleClosePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem("hduy_popup_shown", "true");
  };

  const handlePopupApply = () => {
    handleClosePopup();
    setTimeout(() => {
      const el = document.getElementById("hduy-form-top");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (success) {
      toast.success(t.successMsg);
      setForm({ name: "", email: "", phone: "", district: "", isSC: null });
      setFamilyIdError("");
      dispatch(clearStatus());
    }
    if (error) {
      toast.error(t.errorMsg);
      dispatch(clearStatus());
    }
  }, [success, error, dispatch, t]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneOk = /^[0-9]{10}$/.test(form.phone);
    const emailOk = form.email.trim() === "" || /^\S+@\S+\.\S+$/.test(form.email);

    if (
      !form.name.trim() ||
      !phoneOk ||
      !emailOk ||
      !form.district.trim() ||
      typeof form.isSC !== "boolean"
    ) {
      toast.error(t.validation);
      return;
    }

    const payload = {
      name: form.name.trim(),
      phone: form.phone,
      district: form.district.trim(),
      isSC: form.isSC,
      ...(form.email.trim() && { email: form.email.trim() }),
    };
    dispatch(createLead(payload));
  };

  return (
    <div style={S.page}>
      <style>{css}</style>

      {/* First-visit deadline popup */}
      {showPopup && (
        <div className="hduy-popup-overlay" onClick={handleClosePopup}>
          <div
            className="hduy-popup-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="hduy-popup-close"
              onClick={handleClosePopup}
              aria-label="Close"
            >
              ×
            </button>
            <div className="hduy-popup-icon" aria-hidden><FaTrophy /></div>
            <h3 className="hduy-popup-heading">{t.popupHeading}</h3>
            <p className="hduy-popup-msg">
              {t.popupMsg}
            </p>
            <div className="hduy-popup-date">{t.popupDate}</div>
            <div className="hduy-popup-actions">
              <button className="hduy-popup-btn hduy-popup-btn-primary" onClick={handlePopupApply}>
                {t.popupBtn} →
              </button>
              <button className="hduy-popup-btn hduy-popup-btn-secondary" onClick={handleClosePopup}>
                {t.popupClose}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="hduy-shell">
        {/* Tricolor strip */}
        <div style={S.tricolor}>
          <div style={{ ...S.stripe, background: "#FF9933" }} />
          <div style={{ ...S.stripe, background: "#FFFFFF" }} />
          <div style={{ ...S.stripe, background: "#138808" }} />
        </div>

        {/* Gov bar */}
        <div className="hduy-govbar">
          <div className="hduy-container hduy-govbar-inner">
            <img src="/hsfdc.png" alt="HSFDC" className="hduy-govbar-logo" />
            <span className="hduy-govbar-text">{t.govBar}</span>
            <button
              style={S.langBtn}
              onClick={() => setLang(lang === "en" ? "hi" : "en")}
            >
              {t.langBtn}
            </button>
          </div>
        </div>

      {/* HERO — banner on left, form on right */}
      <section className="hduy-hero">
        <div className="hduy-container hduy-hero-inner">
          <div className="hduy-banner-wrap">
            <div className="hduy-banner-track">
              {[...BANNERS, ...BANNERS].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`हरियाणा ड्रोन उद्यमी योजना ${i + 1}`}
                  className="hduy-banner-img"
                />
              ))}
            </div>
          </div>
          <div className="hduy-form-wrap" id="hduy-form-top">
            <div className="hduy-form-card">
              <div className="hduy-form-ribbon">{t.formHeading}</div>
              <p className="hduy-form-sub">{t.formSub}</p>
              <form onSubmit={handleSubmit} className="hduy-form">
                <div className="hduy-field">
                  <input
                    type="text"
                    name="name"
                    placeholder={t.name + " *"}
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="hduy-field">
                  <input
                    type="email"
                    name="email"
                    placeholder={t.email}
                    value={form.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="hduy-field">
                  <input
                    type="tel"
                    name="phone"
                    placeholder={t.phone + " *"}
                    value={form.phone}
                    onChange={handleChange}
                    maxLength={10}
                    required
                  />
                </div>
                <div className="hduy-field">
                  <input
                    type="text"
                    name="district"
                    placeholder={t.address + " *"}
                    value={form.district}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="hduy-radio-group">
                  <p className="hduy-radio-label">{t.isSC} *</p>
                  <div className="hduy-radio-options">
                    <label className={`hduy-radio ${form.isSC === true ? "is-checked" : ""}`}>
                      <input
                        type="radio"
                        name="isSC"
                        checked={form.isSC === true}
                        onChange={() => setForm({ ...form, isSC: true })}
                      />
                      <span className="hduy-radio-dot" />
                      {t.yes}
                    </label>
                    <label className={`hduy-radio ${form.isSC === false ? "is-checked" : ""}`}>
                      <input
                        type="radio"
                        name="isSC"
                        checked={form.isSC === false}
                        onChange={() => setForm({ ...form, isSC: false })}
                      />
                      <span className="hduy-radio-dot" />
                      {t.no}
                    </label>
                  </div>
                </div>

                <button type="submit" disabled={loading} className="hduy-submit">
                  {loading ? t.submitting : t.submit} →
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* TAGLINE — opening hook */}
      <section className="hduy-band hduy-band-soft hduy-tagline-band">
        <div className="hduy-container hduy-tagline">
          <h2 className="hduy-tagline-h2">{t.taglineHeading}</h2>
          <div className="hduy-divider-c" />
          {t.tagline.map((line, i) => (
            <p key={i} className="hduy-tagline-p">{line}</p>
          ))}
        </div>
      </section>

      {/* ABOUT — 4-card infographic */}
      <section className="hduy-band hduy-about-band">
        <div className="hduy-container hduy-about-info">
          <div className="hduy-about-badge">
            <span className="hduy-about-megaphone" aria-hidden>
              <FaBullhorn />
            </span>
            <span>{t.aboutHeading}</span>
          </div>
          <p className="hduy-about-lead">{t.aboutLead}</p>

          <div className="hduy-about-cards">
            {t.aboutCards.map((c, i) => (
              <div
                key={i}
                className="hduy-about-card"
                style={{ background: c.bg }}
              >
                <div
                  className="hduy-about-card-visual"
                  aria-hidden
                  style={{
                    background: `radial-gradient(circle at center, #fff 60%, ${c.bg} 100%)`,
                    boxShadow: `inset 0 0 0 1px ${c.color}22, 0 6px 14px ${c.color}1f`,
                  }}
                >
                  <img
                    src={c.img}
                    alt=""
                    className="hduy-about-card-vector"
                  />
                </div>
                <div className="hduy-about-card-body">
                  <div
                    className="hduy-about-card-num"
                    style={{ color: c.color, background: "#fff" }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3
                    className="hduy-about-card-title"
                    style={{ color: c.color }}
                  >
                    {c.title}
                  </h3>
                  <div
                    className="hduy-about-card-divider"
                    style={{ borderColor: c.color }}
                  />
                  <p className="hduy-about-card-text">{c.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="hduy-about-tagline">
            <span className="hduy-about-tag-icon" aria-hidden>
              <FaGraduationCap />
            </span>
            <span className="hduy-about-tag-text">{t.aboutTagline}</span>
          </div>
        </div>
      </section>

      {/* INITIATIVE — three pillar callout */}
      <section className="hduy-band hduy-band-soft">
        <div className="hduy-container">
          <h2 className="hduy-h2">{t.initiativeHeading}</h2>
          <div className="hduy-divider-c" />
          <div className="hduy-pillars">
            {t.initiative.map((p, i) => (
              <figure key={i} className="hduy-pillar">
                <img src={p.img} alt="" className="hduy-pillar-img" />
                <div className="hduy-pillar-overlay" />
                <figcaption className="hduy-pillar-caption">
                  <div className="hduy-pillar-num">{i + 1}</div>
                  <div className="hduy-pillar-text">{p.text}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFITS — icon row, no boxes */}
      <section className="hduy-band">
        <div className="hduy-container">
          <h2 className="hduy-h2">{t.benefitsHeading}</h2>
          <div className="hduy-divider-c" />
          <div className="hduy-benefits">
            {t.benefits.map((b, i) => {
              const Icon = b.Icon;
              return (
                <div key={i} className="hduy-benefit" style={{ borderLeftColor: b.color }}>
                  <div
                    className="hduy-benefit-icon"
                    style={{
                      background: `${b.color}1a`,
                      color: b.color,
                    }}
                  >
                    <Icon />
                  </div>
                  <div className="hduy-benefit-text">{b.text}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* EARNING CALLOUT */}
      <section className="hduy-earning-band">
        <div className="hduy-container hduy-earning">
          <div className="hduy-earning-tag">{t.earningHeading}</div>
          <div className="hduy-earning-value">
            {t.earningValue}
            <span className="hduy-earning-unit">{t.earningUnit}</span>
          </div>
          <p className="hduy-earning-sub">{t.earningSub}</p>
        </div>
      </section>

      {/* ELIGIBILITY + WHY — split panel with checks */}
      <section className="hduy-band hduy-band-soft">
        <div className="hduy-container hduy-split">
          <div>
            <h2 className="hduy-h2">{t.eligibilityHeading}</h2>
            <div className="hduy-divider-l" />
            {t.eligibilityIntro && (
              <p className="hduy-split-intro">{t.eligibilityIntro}</p>
            )}
            <ul className="hduy-checklist">
              {t.eligibility.map((x, i) => (
                <li key={i}>{x}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="hduy-h2">{t.whyHeading}</h2>
            <div className="hduy-divider-l" />
            <ul className="hduy-checklist hduy-checklist-saffron">
              {t.why.map((x, i) => (
                <li key={i}>{x}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS — vertical timeline */}
      <section className="hduy-band hduy-band-dark">
        <div className="hduy-container">
          <h2 className="hduy-h2 hduy-h2-light">{t.howHeading}</h2>
          <div className="hduy-divider-c" />
          <div className="hduy-flow">
            {t.how.map((step, i) => {
              const Icon = step.Icon;
              const isLast = i === t.how.length - 1;
              return (
                <React.Fragment key={i}>
                  <div className="hduy-flow-step">
                    <div className="hduy-flow-label">
                      <span className="hduy-flow-label-dot" />
                      {t.howStep} {i + 1}
                    </div>
                    <div className="hduy-flow-text">{step.text}</div>
                    <div className="hduy-flow-icon" aria-hidden>
                      <Icon />
                    </div>
                  </div>
                  {!isLast && (
                    <div className="hduy-flow-arrow" aria-hidden>
                      <FaChevronDown />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </section>

      {/* WORK — horizontal pills */}
      <section className="hduy-band">
        <div className="hduy-container">
          <h2 className="hduy-h2">{t.workHeading}</h2>
          <div className="hduy-divider-c" />
          {t.workIntro && (
            <p className="hduy-work-intro">{t.workIntro}</p>
          )}
          <div className="hduy-work-marquee">
            <div className="hduy-work-track">
              {[...t.work, ...t.work, ...t.work].map((w, i) => (
                <figure key={i} className="hduy-work-card">
                  <img src={w.img} alt={w.text} className="hduy-work-img" />
                  <figcaption className="hduy-work-caption">
                    <span className="hduy-work-title">{w.text}</span>
                    {w.earning && (
                      <span className="hduy-work-earning">
                        <span className="hduy-work-earning-label">
                          {t.workEarningLabel}
                        </span>
                        <span className="hduy-work-earning-value">{w.earning}</span>
                      </span>
                    )}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* IMAGINE — evocative band */}
      <section className="hduy-band hduy-band-dark hduy-imagine-band">
        <div className="hduy-container hduy-imagine">
          <h2 className="hduy-h2 hduy-h2-light">{t.imagineHeading}</h2>
          <div className="hduy-divider-c" />
          <img
            src={t.imagineQuoteImg}
            alt=""
            className="hduy-imagine-quote-img"
            key={lang}
          />
        </div>
      </section>

      {/* URGENCY — limited seats CTA */}
      <section className="hduy-urgency-band">
        <div className="hduy-container hduy-urgency">
          <div className="hduy-urgency-badge">500</div>
          <h2 className="hduy-urgency-h2">{t.urgencyHeading}</h2>
          <ul className="hduy-urgency-list">
            {t.urgency.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
          <p className="hduy-urgency-note">{t.urgencyNote}</p>
          <div className="hduy-urgency-cta-wrap">
            <h3 className="hduy-urgency-cta-h">{t.ctaHeading}</h3>
            <p className="hduy-urgency-cta-sub">{t.ctaSub}</p>
            <a href="#hduy-form-top" className="hduy-urgency-btn">
              {t.submit} →
            </a>
          </div>
        </div>
      </section>

        <footer className="hduy-footer">
          <div className="hduy-container">
            Copyright © {new Date().getFullYear()}. Drone Planet | All rights reserved
          </div>
        </footer>
      </div>
    </div>
  );
};

const S = {
  page: {
    fontFamily: "'Noto Sans', 'Segoe UI', Arial, sans-serif",
    background: "#fafaf7",
    color: "#1a1a1a",
    minHeight: "100vh",
  },
  tricolor: { display: "flex", height: "5px" },
  stripe: { flex: 1 },
  govBar: {
    background: "#0b3d2e",
    color: "#fff",
    padding: "10px 20px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  emblem: { fontSize: "18px" },
  govBarText: { flex: 1, fontSize: "13.5px", fontWeight: 500 },
  langBtn: {
    background: "#FF9933",
    color: "#fff",
    border: "none",
    padding: "6px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "13px",
  },
  footer: {
    background: "#0b3d2e",
    color: "#cfe6dc",
    textAlign: "center",
    padding: "16px",
    fontSize: "13px",
  },
};

const css = `
* { box-sizing: border-box; }
.hduy-shell {
  width: 100%;
  background: #fafaf7;
}
.hduy-govbar {
  background: #ffffff;
  border-bottom: 1px solid #e7e2d6;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.hduy-govbar-inner {
  display: flex; align-items: center; gap: 16px;
  flex-wrap: wrap;
  padding-top: 10px; padding-bottom: 10px;
  min-height: 70px;
}
.hduy-govbar-logo {
  height: 56px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}
.hduy-govbar-text {
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #4a1d6f;
  letter-spacing: 0.2px;
  line-height: 1.3;
}
.hduy-footer {
  background: #0b3d2e; color: #cfe6dc;
  text-align: center; padding: 18px 0; font-size: 13px;
}
.hduy-hero {
  position: relative;
  background: linear-gradient(135deg, #f3efe2 0%, #e9efe3 100%);
  padding: 32px 0;
  border-bottom: 4px solid #FF9933;
}
.hduy-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 1fr);
  gap: 28px;
  align-items: center;
}
.hduy-banner-wrap {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.18);
  background: #f3efe2;
  width: 100%;
}
.hduy-banner-track {
  display: flex;
  width: 400%;        /* 4 slides total (2 images × duplicated for seamless loop) */
  animation: hduyBannerScroll 14s linear infinite;
}
.hduy-banner-wrap:hover .hduy-banner-track { animation-play-state: paused; }
.hduy-banner-img {
  flex: 0 0 25%;      /* each slide = 1/4 of track width = 100% of wrap */
  width: 25%;
  height: auto;
  display: block;
}
@keyframes hduyBannerScroll {
  0%, 45%   { transform: translateX(0%); }
  50%, 95%  { transform: translateX(-25%); }
  100%      { transform: translateX(-50%); } /* snaps back to 0 — seamless because slide 3 == slide 1 */
}

.hduy-form-wrap { display: flex; }
.hduy-form-card {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 16px 18px 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border-top: 4px solid #FF9933;
  display: flex;
  flex-direction: column;
}
.hduy-form-ribbon {
  display: inline-block;
  background: #0b3d2e;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  padding: 6px 14px;
  border-radius: 4px;
  margin-bottom: 6px;
}
.hduy-form-sub {
  margin: 0 0 10px;
  font-size: 12.5px;
  color: #444;
  line-height: 1.4;
}
.hduy-form { display: flex; flex-direction: column; gap: 8px; }
.hduy-field input, .hduy-field textarea {
  width: 100%;
  padding: 8px 11px;
  border: 1px solid #d3d6cf;
  border-radius: 5px;
  font-size: 13.5px;
  outline: none;
  font-family: inherit;
  background: #fff;
  transition: border-color .15s, box-shadow .15s;
  box-sizing: border-box;
}
.hduy-field textarea { min-height: 38px; }
.hduy-field-error {
  display: block;
  margin-top: 4px;
  font-size: 11.5px;
  color: #c0392b;
  font-weight: 500;
  padding-left: 2px;
}
.hduy-field input:focus, .hduy-field textarea:focus {
  border-color: #FF9933;
  box-shadow: 0 0 0 3px rgba(255,153,51,0.18);
}
.hduy-field.has-error input {
  border-color: #c0392b;
  box-shadow: 0 0 0 3px rgba(192,57,43,0.12);
}
.hduy-radio-group {
  margin-top: 2px;
  padding: 8px 10px;
  background: #f6f8f4;
  border: 1px solid #e2e6dd;
  border-radius: 5px;
}
.hduy-radio-label {
  margin: 0 0 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #0b3d2e;
  line-height: 1.35;
}
.hduy-radio-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.hduy-radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 80px;
  padding: 6px 10px;
  border: 1.5px solid #d3d6cf;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: #2a2a2a;
  transition: border-color .15s, background .15s, color .15s;
  user-select: none;
}
.hduy-radio input { position: absolute; opacity: 0; pointer-events: none; }
.hduy-radio-dot {
  width: 16px; height: 16px;
  border: 2px solid #b6bcae;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
  transition: border-color .15s;
}
.hduy-radio.is-checked {
  border-color: #FF9933;
  background: #fff7ec;
  color: #0b3d2e;
}
.hduy-radio.is-checked .hduy-radio-dot { border-color: #FF9933; }
.hduy-radio.is-checked .hduy-radio-dot::after {
  content: "";
  position: absolute; inset: 2px;
  background: #FF9933;
  border-radius: 50%;
}

.hduy-submit {
  margin-top: 4px;
  background: linear-gradient(90deg, #FF9933, #ff7e1a);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 12px rgba(255,126,26,0.35);
  transition: transform .12s;
}
.hduy-submit:hover { transform: translateY(-1px); }
.hduy-submit:disabled { opacity: 0.7; cursor: not-allowed; }

.hduy-band { padding: 56px 0; }
.hduy-band-soft { background: #f3f6f2; }
.hduy-band-dark {
  background: linear-gradient(135deg, #0b3d2e 0%, #134e3a 100%);
  color: #fff;
}
.hduy-container { max-width: 1440px; margin: 0 auto; padding: 0 32px; width: 100%; box-sizing: border-box; }

.hduy-section-tag {
  display: inline-block;
  background: #FF9933;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 20px;
  margin-bottom: 18px;
}
.hduy-about-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(260px, 1fr);
  gap: 48px;
  align-items: center;
}
.hduy-about-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.hduy-about-visual::before {
  content: "";
  position: absolute;
  inset: 10% 8%;
  background: radial-gradient(circle at 50% 50%, rgba(255,153,51,0.18) 0%, transparent 65%);
  z-index: 0;
}
.hduy-about-img {
  position: relative;
  z-index: 1;
  max-width: 100%;
  max-height: 460px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 14px 28px rgba(0,0,0,0.18));
  transition: transform .4s ease;
}
.hduy-about-img:hover { transform: translateY(-4px) scale(1.02); }

.hduy-about-p {
  font-size: 17px;
  line-height: 1.85;
  color: #2a2a2a;
  margin: 0 0 14px;
  max-width: 880px;
}

.hduy-h2 {
  font-size: 30px;
  font-weight: 800;
  margin: 0 0 8px;
  color: #0b3d2e;
  text-align: center;
}
.hduy-h2-light { color: #fff; }
.hduy-divider-c {
  width: 80px; height: 4px; background: #FF9933;
  margin: 0 auto 32px; border-radius: 2px;
}
.hduy-divider-l {
  width: 60px; height: 3px; background: #FF9933;
  margin-bottom: 18px; border-radius: 2px;
}

/* Benefits — icon row, no card boxes */
.hduy-benefits {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 28px 24px;
}
.hduy-benefit {
  display: flex; align-items: center; gap: 14px;
  border-left: 3px solid #FF9933;
  padding: 6px 0 6px 16px;
  transition: transform .2s ease;
}
.hduy-benefit:hover { transform: translateX(3px); }
.hduy-benefit-icon {
  flex-shrink: 0;
  width: 44px; height: 44px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 50%;
  font-size: 22px;
  line-height: 1;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  transition: transform .25s ease;
}
.hduy-benefit:hover .hduy-benefit-icon { transform: scale(1.08); }
.hduy-benefit-icon svg { display: block; }
.hduy-benefit-text {
  font-size: 15.5px; line-height: 1.5;
  color: #2a2a2a; font-weight: 500;
}

/* Split */
.hduy-split {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 48px;
}
.hduy-split .hduy-h2 {
  text-align: left;
  min-height: 80px;
  display: flex;
  align-items: flex-start;
}

.hduy-checklist {
  list-style: none; padding: 0; margin: 0;
}
.hduy-checklist li {
  position: relative;
  padding: 10px 0 10px 32px;
  font-size: 15.5px;
  line-height: 1.55;
  color: #2a2a2a;
  border-bottom: 1px dashed #d6dad1;
}
.hduy-checklist li:last-child { border-bottom: none; }
.hduy-checklist li::before {
  content: "✔";
  position: absolute; left: 0; top: 10px;
  width: 22px; height: 22px;
  background: #138808; color: #fff;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700;
}
.hduy-checklist-saffron li::before { background: #FF9933; }

/* How It Works — step flow with arrows */
.hduy-flow {
  max-width: 820px;
  margin: 24px auto 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
}
.hduy-flow-step {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 22px;
  padding: 18px 22px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,153,51,0.18);
  border-left: 4px solid #FF9933;
  border-radius: 10px;
  transition: transform .3s cubic-bezier(.2,.7,.3,1), background .25s ease, border-color .25s ease, box-shadow .25s ease;
  cursor: default;
}
.hduy-flow-step:hover {
  transform: translateX(4px);
  background: rgba(255,255,255,0.08);
  border-color: rgba(255,153,51,0.5);
  box-shadow: 0 8px 24px rgba(0,0,0,0.25);
}
.hduy-flow-label {
  display: inline-flex; align-items: center; gap: 8px;
  background: #FF9933;
  color: #fff;
  font-size: 12px; font-weight: 800;
  letter-spacing: 1.2px; text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 20px;
  white-space: nowrap;
  box-shadow: 0 4px 10px rgba(255,153,51,0.35);
  transition: transform .25s ease;
}
.hduy-flow-step:hover .hduy-flow-label { transform: scale(1.05); }
.hduy-flow-label-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #fff;
  display: inline-block;
}
.hduy-flow-text {
  font-size: 17px;
  line-height: 1.5;
  color: #ffffff;
  font-weight: 500;
}
.hduy-flow-icon {
  flex-shrink: 0;
  width: 52px; height: 52px;
  border-radius: 50%;
  background: rgba(255,153,51,0.15);
  color: #FF9933;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 24px;
  border: 1.5px solid rgba(255,153,51,0.4);
  transition: transform .35s ease, background .25s ease, color .25s ease;
}
.hduy-flow-step:hover .hduy-flow-icon {
  transform: rotate(-6deg) scale(1.08);
  background: #FF9933;
  color: #fff;
}
.hduy-flow-icon svg { display: block; }

.hduy-flow-arrow {
  align-self: center;
  height: 32px;
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,153,51,0.7);
  font-size: 18px;
  margin: 4px 0;
  position: relative;
  animation: hduyArrowBounce 1.8s ease-in-out infinite;
}
.hduy-flow-arrow::before,
.hduy-flow-arrow::after {
  content: "";
  position: absolute; left: 50%; transform: translateX(-50%);
  width: 2px; height: 12px;
  background: linear-gradient(180deg, rgba(255,153,51,0.6), rgba(255,153,51,0));
  pointer-events: none;
}
.hduy-flow-arrow::before { top: -10px; }
.hduy-flow-arrow::after  { bottom: -10px; transform: translateX(-50%) rotate(180deg); }
@keyframes hduyArrowBounce {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(3px); }
}

/* Work — image marquee with text overlay */
.hduy-work-marquee {
  position: relative;
  overflow: hidden;
  margin-top: 8px;
  padding: 8px 0;
  -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 60px, #000 calc(100% - 60px), transparent 100%);
          mask-image: linear-gradient(90deg, transparent 0, #000 60px, #000 calc(100% - 60px), transparent 100%);
}
.hduy-work-track {
  display: flex;
  gap: 22px;
  width: max-content;
  animation: hduyWorkScroll 30s linear infinite;
}
.hduy-work-marquee:hover .hduy-work-track { animation-play-state: paused; }
.hduy-work-card {
  position: relative;
  flex: 0 0 auto;
  width: 360px;
  aspect-ratio: 4 / 3;
  margin: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.18);
  background: #0b3d2e;
}
.hduy-work-img {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
}
.hduy-work-card:hover .hduy-work-img { transform: scale(1.06); }
.hduy-work-caption {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px;
  background: linear-gradient(180deg, rgba(0,0,0,0) 25%, rgba(0,0,0,0.45) 55%, rgba(11,61,46,0.95) 100%);
  color: #fff;
}
.hduy-work-title {
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  border-left: 3px solid #FF9933;
  padding-left: 12px;
}
.hduy-work-earning {
  display: inline-flex;
  flex-direction: column;
  align-self: flex-start;
  background: rgba(255,153,51,0.95);
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.25);
}
.hduy-work-earning-label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  opacity: 0.95;
  line-height: 1;
  margin-bottom: 3px;
}
.hduy-work-earning-value {
  font-size: 14.5px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
@keyframes hduyWorkScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(calc(-33.3333% - 7.33px)); } /* 1/3 of track + 1/3 of gap = exactly one full set */
}

/* About — 4-card infographic */
.hduy-about-band {
  background:
    radial-gradient(ellipse at top, rgba(255,153,51,0.06), transparent 60%),
    #fffaf0;
}
.hduy-about-info { text-align: center; }

.hduy-about-badge {
  display: inline-flex; align-items: center; gap: 12px;
  background: linear-gradient(90deg, #FF9933, #ff7e1a);
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 12px 32px 12px 18px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(255,126,26,0.35);
  position: relative;
}
.hduy-about-badge::before,
.hduy-about-badge::after {
  content: "";
  position: absolute; top: 50%;
  width: 60px; height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255,153,51,0.45));
  transform: translateY(-50%);
}
.hduy-about-badge::before { right: calc(100% + 14px); transform: translateY(-50%) scaleX(-1); }
.hduy-about-badge::after  { left:  calc(100% + 14px); }
.hduy-about-megaphone {
  display: inline-flex; align-items: center; justify-content: center;
  width: 36px; height: 36px;
  border-radius: 50%;
  background: #fff;
  color: #FF9933;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
}
.hduy-about-megaphone svg { display: block; }

.hduy-about-lead {
  margin: 22px auto 36px;
  max-width: 760px;
  font-size: 16.5px;
  line-height: 1.7;
  color: #2a2a2a;
}

.hduy-about-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  text-align: left;
}
.hduy-about-card {
  display: grid;
  grid-template-columns: 38% 1fr;
  align-items: center;
  gap: 0;
  border-radius: 16px;
  padding: 22px 24px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.05);
  transition: transform .25s ease, box-shadow .25s ease;
  border: 1px solid rgba(0,0,0,0.04);
  min-height: 200px;
}
.hduy-about-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0,0,0,0.1);
}
.hduy-about-card-visual {
  position: relative;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  width: 100%;
  max-width: 150px;
  margin: 0 auto;
  overflow: hidden;
  transition: transform .35s ease;
}
.hduy-about-card:hover .hduy-about-card-visual { transform: scale(1.04); }
.hduy-about-card-vector {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform .35s ease;
}
.hduy-about-card:hover .hduy-about-card-vector { transform: scale(1.06); }
.hduy-about-card-body {
  display: flex; flex-direction: column;
  padding-left: 16px;
}
.hduy-about-card-num {
  display: inline-block;
  align-self: flex-start;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1px;
  padding: 3px 10px;
  border-radius: 4px;
  margin-bottom: 8px;
  border: 1.5px solid currentColor;
}
.hduy-about-card-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  line-height: 1.25;
}
.hduy-about-card-divider {
  width: 100%;
  border: 0;
  border-top: 1.5px dashed;
  opacity: 0.5;
  margin: 0 0 10px;
}
.hduy-about-card-text {
  margin: 0;
  font-size: 14.5px;
  line-height: 1.6;
  color: #333;
}

.hduy-about-tagline {
  margin: 36px auto 0;
  display: inline-flex; align-items: center; gap: 14px;
  background: linear-gradient(90deg, #fff7ec, #fff7ec);
  border: 2px solid #FF9933;
  padding: 14px 28px;
  border-radius: 8px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 18px;
  color: #0b3d2e;
  box-shadow: 0 6px 16px rgba(255,153,51,0.18);
}
.hduy-about-tag-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 36px; height: 36px;
  background: #FF9933; color: #fff;
  border-radius: 50%; font-size: 18px;
  flex-shrink: 0;
}
.hduy-about-tag-text {
  background: linear-gradient(90deg, #0b3d2e 0%, #138808 50%, #FF9933 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

/* Tagline band */
.hduy-tagline-band { padding: 60px 0 50px; }
.hduy-tagline { text-align: center; max-width: 920px; margin: 0 auto; }
.hduy-tagline-h2 {
  font-size: 32px; font-weight: 800; color: #0b3d2e;
  margin: 0 0 8px; line-height: 1.25;
}
.hduy-tagline-h2 + .hduy-divider-c { margin-bottom: 22px; }
.hduy-tagline-p {
  font-size: 17px; line-height: 1.75;
  color: #2a2a2a; margin: 0 0 12px;
}
.hduy-tagline-p:first-of-type { font-weight: 600; color: #0b3d2e; font-size: 18.5px; }

/* Initiative pillars — image cards with text overlay */
.hduy-pillars {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 22px;
  margin: 8px 0 0;
}
.hduy-pillar {
  position: relative;
  margin: 0;
  border-radius: 14px;
  overflow: hidden;
  aspect-ratio: 4 / 3;
  box-shadow: 0 8px 22px rgba(0,0,0,0.18);
  border-top: 4px solid #FF9933;
  transition: transform .3s ease, box-shadow .3s ease;
  isolation: isolate;
}
.hduy-pillar:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 32px rgba(0,0,0,0.25);
}
.hduy-pillar-img {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  transition: transform .6s ease;
}
.hduy-pillar:hover .hduy-pillar-img { transform: scale(1.07); }
.hduy-pillar-overlay {
  position: absolute; inset: 0;
  background:
    linear-gradient(180deg, rgba(0,0,0,0) 30%, rgba(0,0,0,0.45) 65%, rgba(11,61,46,0.92) 100%);
  pointer-events: none;
}
.hduy-pillar-caption {
  position: absolute;
  left: 0; right: 0; bottom: 0;
  padding: 22px 22px 22px;
  display: flex; align-items: flex-end; gap: 16px;
  color: #fff;
}
.hduy-pillar-num {
  flex-shrink: 0;
  width: 52px; height: 52px;
  border-radius: 50%;
  background: #FF9933;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px; font-weight: 800; color: #fff;
  box-shadow: 0 0 0 4px rgba(255,255,255,0.18), 0 6px 14px rgba(255,126,26,0.45);
}
.hduy-pillar-text {
  font-size: 17px; line-height: 1.45; font-weight: 700;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
  border-left: 3px solid #FF9933;
  padding-left: 12px;
  padding-bottom: 4px;
}

/* Split intro */
.hduy-split-intro {
  font-size: 14.5px; color: #555;
  margin: 0 0 14px; font-style: italic;
}

/* Earning callout band */
.hduy-earning-band {
  background: linear-gradient(135deg, #FF9933 0%, #ff7e1a 100%);
  color: #fff;
  padding: 50px 0;
  position: relative;
  overflow: hidden;
}
.hduy-earning-band::before,
.hduy-earning-band::after {
  content: ""; position: absolute; border-radius: 50%;
  background: rgba(255,255,255,0.08); pointer-events: none;
}
.hduy-earning-band::before { width: 280px; height: 280px; top: -100px; left: -80px; }
.hduy-earning-band::after  { width: 220px; height: 220px; bottom: -90px; right: -60px; }
.hduy-earning { position: relative; text-align: center; z-index: 1; }
.hduy-earning-tag {
  display: inline-block;
  background: rgba(255,255,255,0.18);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px; font-weight: 700;
  letter-spacing: 1.2px; text-transform: uppercase;
  margin-bottom: 14px;
}
.hduy-earning-value {
  font-size: clamp(48px, 8vw, 80px);
  font-weight: 800;
  line-height: 1;
  margin-bottom: 14px;
  display: flex; align-items: baseline; justify-content: center; gap: 14px;
  flex-wrap: wrap;
}
.hduy-earning-unit {
  font-size: clamp(16px, 2vw, 22px);
  font-weight: 600;
  opacity: 0.92;
}
.hduy-earning-sub {
  font-size: 17px; line-height: 1.6; margin: 0;
  max-width: 640px; margin-left: auto; margin-right: auto;
  opacity: 0.95;
}

/* Work intro */
.hduy-work-intro {
  text-align: center;
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  max-width: 720px;
  margin: -8px auto 22px;
}

/* Imagine band */
.hduy-imagine-band { padding: 70px 0; }
.hduy-imagine { text-align: center; max-width: 1240px; margin: 0 auto; }
.hduy-imagine-quote-img {
  display: block;
  margin: 32px auto 0;
  width: 100%;
  max-width: 1280px;
  height: auto;
  object-fit: contain;
  object-position: center;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(0,0,0,0.4);
  animation: hduyQuoteFade .5s ease;
}
@keyframes hduyQuoteFade {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Urgency band */
.hduy-urgency-band {
  background: linear-gradient(135deg, #0b3d2e 0%, #134e3a 100%);
  color: #fff;
  padding: 60px 0 70px;
  position: relative;
  border-top: 4px solid #FF9933;
}
.hduy-urgency { text-align: center; max-width: 780px; margin: 0 auto; }
.hduy-urgency-badge {
  display: inline-flex; align-items: center; justify-content: center;
  width: 110px; height: 110px;
  border-radius: 50%;
  background: #FF9933;
  font-size: 38px; font-weight: 800; color: #fff;
  margin-bottom: 18px;
  box-shadow: 0 0 0 6px rgba(255,153,51,0.18), 0 12px 28px rgba(0,0,0,0.3);
}
.hduy-urgency-h2 {
  font-size: 28px; font-weight: 800; color: #fff;
  margin: 0 0 18px; line-height: 1.3;
}
.hduy-urgency-list {
  list-style: none; padding: 0; margin: 0 0 16px;
  display: inline-flex; flex-direction: column; gap: 8px;
}
.hduy-urgency-list li {
  font-size: 16px; color: #d6e4dc;
  position: relative; padding-left: 22px;
  text-align: left;
}
.hduy-urgency-list li::before {
  content: "✦"; position: absolute; left: 0; color: #FF9933;
}
.hduy-urgency-note {
  font-size: 15.5px; font-style: italic; color: #ffd9a8;
  margin: 0 0 32px;
}
.hduy-urgency-cta-wrap {
  margin-top: 20px;
  padding-top: 28px;
  border-top: 1px dashed rgba(255,153,51,0.35);
}
.hduy-urgency-cta-h {
  font-size: 26px; font-weight: 800;
  color: #FF9933; margin: 0 0 6px;
}
.hduy-urgency-cta-sub {
  font-size: 15.5px; color: #d6e4dc; margin: 0 0 18px;
}
.hduy-urgency-btn {
  display: inline-block;
  background: linear-gradient(90deg, #FF9933, #ff7e1a);
  color: #fff;
  padding: 14px 36px;
  border-radius: 6px;
  font-size: 16px; font-weight: 700;
  text-decoration: none;
  letter-spacing: 0.3px;
  box-shadow: 0 6px 16px rgba(255,126,26,0.4);
  transition: transform .15s ease, box-shadow .15s ease;
}
.hduy-urgency-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(255,126,26,0.55);
  color: #fff;
}

/* Responsive */
@media (max-width: 1100px) {
  .hduy-container { padding: 0 24px; }
  .hduy-hero-inner { grid-template-columns: minmax(0, 1.3fr) minmax(300px, 1fr); gap: 20px; }
}
@media (max-width: 960px) {
  .hduy-hero { padding: 24px 0; }
  .hduy-hero-inner { grid-template-columns: 1fr; gap: 20px; }
  .hduy-banner-wrap { aspect-ratio: auto; }
  .hduy-banner-img { width: 25%; height: auto; }
  .hduy-h2 { font-size: 24px; }
  .hduy-band { padding: 40px 0; }
  .hduy-about-p { font-size: 15.5px; }
  .hduy-about-grid { grid-template-columns: 1fr; gap: 28px; }
  .hduy-about-img { max-height: 360px; }

  .hduy-about-badge { font-size: 16px; padding: 10px 20px 10px 14px; letter-spacing: 1px; }
  .hduy-about-badge::before,
  .hduy-about-badge::after { display: none; }
  .hduy-about-megaphone { width: 30px; height: 30px; font-size: 16px; }
  .hduy-about-lead { font-size: 14.5px; margin-bottom: 24px; }
  .hduy-about-cards { grid-template-columns: 1fr; gap: 16px; }
  .hduy-about-card { grid-template-columns: 32% 1fr; padding: 16px 18px; min-height: 0; }
  .hduy-about-card-title { font-size: 15.5px; }
  .hduy-about-card-text { font-size: 13.5px; }
  .hduy-about-tagline { font-size: 14px; padding: 10px 18px; gap: 10px; }
  .hduy-about-tag-icon { width: 28px; height: 28px; font-size: 14px; }
  .hduy-form-ribbon { font-size: 16px; }
  .hduy-benefits { gap: 22px 18px; }
  .hduy-split { gap: 32px; }
  .hduy-split .hduy-h2 { min-height: 0; }

  .hduy-flow-step {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 10px 14px;
    padding: 14px 16px;
  }
  .hduy-flow-label {
    grid-column: 1;
    grid-row: 1;
    justify-self: start;
    font-size: 11px; padding: 5px 10px;
  }
  .hduy-flow-icon {
    grid-column: 2;
    grid-row: 1 / span 2;
    align-self: center;
    width: 44px; height: 44px; font-size: 20px;
  }
  .hduy-flow-text {
    grid-column: 1;
    grid-row: 2;
    font-size: 15.5px;
  }
  .hduy-flow-arrow { font-size: 16px; }

  .hduy-tagline-h2 { font-size: 24px; }
  .hduy-tagline-p { font-size: 15.5px; }
  .hduy-pillars { gap: 14px; }
  .hduy-pillar-caption { padding: 16px 16px 18px; gap: 12px; }
  .hduy-pillar-num { width: 42px; height: 42px; font-size: 18px; }
  .hduy-pillar-text { font-size: 15px; }
  .hduy-earning-band { padding: 36px 0; }
  .hduy-earning-sub { font-size: 15px; }
  .hduy-imagine-band { padding: 48px 0; }
  .hduy-imagine-quote-img {
    max-width: 100%;
    border-radius: 10px;
    min-height: 0;
    height: auto;
    aspect-ratio: auto;
    object-fit: contain;
  }
  .hduy-urgency-band { padding: 44px 0 52px; }
  .hduy-urgency-h2 { font-size: 22px; }
  .hduy-urgency-badge { width: 88px; height: 88px; font-size: 30px; }
  .hduy-urgency-cta-h { font-size: 22px; }
}
@media (max-width: 600px) {
  .hduy-container { padding: 0 16px; }
  .hduy-work-card { width: 260px; }
  .hduy-work-title { font-size: 14.5px; }
  .hduy-work-earning-value { font-size: 13px; }
  .hduy-imagine-quote-img {
    min-height: 0;
    height: auto;
    aspect-ratio: auto;
    object-fit: contain;
  }
  .hduy-govbar-inner { gap: 10px; min-height: 60px; }
  .hduy-govbar-logo { height: 44px; }
  .hduy-govbar-text { font-size: 13.5px; }
  .hduy-h2 { font-size: 22px; }
  .hduy-band { padding: 32px 0; }
  .hduy-form-card { padding: 18px 16px 16px; }
  .hduy-pill { padding: 10px 16px; font-size: 14px; }
  .hduy-benefits { grid-template-columns: 1fr; }
  .hduy-checklist li { font-size: 14.5px; padding-left: 30px; }
}

/* ── First-visit popup ── */
.hduy-popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: hduyOverlayIn .2s ease;
}
@keyframes hduyOverlayIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.hduy-popup-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 36px 32px 28px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  border-top: 4px solid #FF9933;
  animation: hduyCardIn .25s cubic-bezier(.2,.8,.3,1);
}
@keyframes hduyCardIn {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.hduy-popup-close {
  position: absolute;
  top: 10px; right: 12px;
  background: none;
  border: 1px solid #ddd;
  width: 28px; height: 28px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  color: #888;
  display: flex; align-items: center; justify-content: center;
  transition: border-color .15s, color .15s, background .15s;
  font-family: inherit;
}
.hduy-popup-close:hover { border-color: #aaa; color: #333; background: #f5f5f5; }

.hduy-popup-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px; height: 52px;
  border-radius: 50%;
  background: #fff7ec;
  border: 1.5px solid #ffd59e;
  color: #e07b00;
  font-size: 22px;
  margin-bottom: 14px;
}
.hduy-popup-icon svg { display: block; }

.hduy-popup-heading {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
}

.hduy-popup-msg {
  margin: 0 0 4px;
  font-size: 14.5px;
  line-height: 1.6;
  color: #555;
}

.hduy-popup-date {
  display: inline-block;
  background: #0b3d2e;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 7px 20px;
  border-radius: 6px;
  margin: 10px 0 22px;
}

.hduy-popup-actions {
  display: flex;
  gap: 12px;
  margin-top: 22px;
}
.hduy-popup-btn {
  flex: 1;
  padding: 11px 0;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.2px;
  transition: background .15s ease, transform .15s ease, border-color .15s;
  font-family: inherit;
  border: 1.5px solid transparent;
}
.hduy-popup-btn-primary {
  background: #FF9933;
  color: #fff;
  border-color: #FF9933;
}
.hduy-popup-btn-primary:hover { background: #e8891e; border-color: #e8891e; transform: translateY(-1px); }
.hduy-popup-btn-secondary {
  background: #fff;
  color: #444;
  border-color: #d0d0d0;
}
.hduy-popup-btn-secondary:hover { background: #f5f5f5; border-color: #bbb; color: #222; }

@media (max-width: 480px) {
  .hduy-popup-card { padding: 28px 18px 22px; }
  .hduy-popup-heading { font-size: 16px; }
  .hduy-popup-date { font-size: 16px; padding: 6px 16px; }
  .hduy-popup-actions { gap: 10px; }
  .hduy-popup-btn { padding: 10px 0; font-size: 14px; }
}
`;

export default HduyLandingPage;
